import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
    user: JSON.parse(localStorage.getItem("user")) || {},
    token: localStorage.getItem("token") || "",
    tokenVerified: false, // Add this
};

const authSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        setLogin: (state, action) => {
            const { token, user } = action.payload;
            state.token = token;
            state.user = user;
            state.tokenVerified = true; // Add this
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));
        },
        setLogout: (state) => {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            state.user = {};
            state.token = "";
            state.tokenVerified = false; // Add this
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(verifyToken.pending, (state) => {
                state.tokenVerified = false;
            })
            .addCase(verifyToken.fulfilled, (state) => {
                state.tokenVerified = true;
            })
            .addCase(verifyToken.rejected, (state) => {
                state.tokenVerified = false;
            });
    }
});


export const verifyToken = createAsyncThunk(
    'auth/verifyToken',
    async (_, { getState, dispatch }) => {
        const { token } = getState().auth;
        if (!token) throw new Error('No token');
        
        const response = await fetch("https://api.up2smart.com:5001/v1/verification", {
        // const response = await fetch("https://192.168.0.102:5001/v1/verification", {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
        });
        
        if (!response.ok) {
            dispatch(setLogout());
            throw new Error('Token invalid');
        }
        return true;
    }
);
export const { setLogin, setLogout } = authSlice.actions;

export default authSlice.reducer;